import { CollectionEntityType, CollectionFetchType } from 'components/Collection/model';
import { QueryClient } from 'react-query';

export const queryClient = new QueryClient();

export function mutateQuery<T>(key: string[], f: (current?: T) => T) {
  const current = queryClient.getQueryData(key) as T;
  queryClient.setQueryData(key, f(current));
}

export const queryKeys = {
  allUserPoints: () => ['userPoints'],
  userPoints: (accountId?: string) => ['userPoints', accountId],
  eggs: (ethAddress: string) => ['eggs', ethAddress],
  gribbles: (ethAddress: string) => ['gribbles', ethAddress],
  referralCode: (userId: string) => ['referralCode', userId],
  referralRewards: (userId: string) => ['referralRewards', userId],
  games: () => ['games'],
  leaderboard: (gameId: string, contestName: string, skip?: number, take?: number) => [
    'leaderboard',
    gameId,
    contestName,
    skip,
    take,
  ],
  userLeaderboard: (gameId: string, leaderboardName: string) => [
    'userLeaderboard',
    gameId,
    leaderboardName,
  ],
  collectionStats: () => ['collectionStats'],
  collection: (collection: CollectionFetchType) => ['collection', collection],
  collectionEntityMetadata: (entity: CollectionEntityType, id: string | number) => [
    'collectionEntityMetadata',
    entity,
    id,
  ],
};
